import { SEARCH_OBJECT_TYPE } from '@common/GlobalSearch/constants';
import { SEARCH_TRACKING_TYPE } from '@common/GlobalSearch/constants/searchTracking';

export const mapObjectTypeToTrackingType = (objectType: string) => {
    if (!(objectType in SEARCH_OBJECT_TYPE)) {
        return null;
    }

    return {
        [SEARCH_OBJECT_TYPE.product]: SEARCH_TRACKING_TYPE.productDetail,
        [SEARCH_OBJECT_TYPE.page]: SEARCH_TRACKING_TYPE.brandPage,
        [SEARCH_OBJECT_TYPE.brandwall]: SEARCH_TRACKING_TYPE.brand,
    }[objectType];
};
